import { useCallback } from 'react';
import { Form } from 'components/@shared/Form/Form';
import { Button, Stack } from '@mui/material';
import { ChangePasswordFormData } from 'types/auth';
import { initialValues } from './constants';
import { validationSchema } from './validation';
import { FormPasswordInput } from 'components/@shared/Form/PasswordInput';

interface Props {
    onChangePassword: (password: string) => void;
}

export const ChangePasswordForm = ({ onChangePassword }: Props) => {
    const handleSubmit = useCallback(
        (values: ChangePasswordFormData) => onChangePassword(values.password),
        [onChangePassword],
    );

    return (
        <Form initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
            <Stack gap={2} pt={5} pb={3} maxWidth={380} mx="auto">
                <FormPasswordInput name="password" label="Password" fullWidth size="small" />
                <FormPasswordInput name="confirmPassword" label="Confirm Password" fullWidth size="small" />
                <Button variant="contained" type="submit" fullWidth>
                    Change Password
                </Button>
            </Stack>
        </Form>
    );
};
